module.exports = __webpack_public_path__ + "static/media/04.ce5b57c0.png";